<template>
  <component
    :is="product.link ? 'a' : 'div'"
    class="pcard"
    :data-site-entry="analyticsTarget"
    :href="product.link || null"
    :target="product.link ? '_blank' : null"
    :rel="product.link ? 'noopener' : null"
  >
    <div class="pcard-top">
      <span class="pcard-type">
        <i class="pcard-dot" :style="{ background: product.accent }"></i>
        {{ product.type }}
      </span>
      <span class="pcard-status">{{ statusText }}</span>
    </div>

    <h3 class="pcard-name">{{ product.name }}</h3>
    <p class="pcard-desc">{{ product.desc }}</p>

    <div class="pcard-tags" v-if="product.tags && product.tags.length">
      <span v-for="t in product.tags" :key="t" class="pcard-tag">{{ t }}</span>
    </div>

    <div class="pcard-foot">
      <span class="pcard-cta" v-if="product.link">去看看 &rarr;</span>
      <span class="pcard-hint" v-else>{{ hintText }}</span>
      <img
        v-if="product.qrcode"
        data-zoom
        class="pcard-qr"
        :src="product.qrcode"
        :alt="product.name + ' 小程序码'"
      />
    </div>
  </component>
</template>

<script>
import { productTarget } from "@/utils/site-analytics";
const STATUS_TEXT = {
  running: "在运营",
  building: "开发中",
  opensource: "开源",
  service: "对外服务"
};

export default {
  name: "ProductCard",
  props: {
    product: {
      type: Object,
      required: true
    }
  },
  computed: {
    analyticsTarget() { return productTarget(this.product.name); },
    statusText() {
      return STATUS_TEXT[this.product.status] || "";
    },
    hintText() {
      const p = this.product;
      if (p.hint) return p.hint;
      if (p.appid) return "微信搜「" + p.name + "」";
      return "合作与咨询见页脚";
    }
  }
};
</script>

<style scoped>
.pcard {
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  padding: 26px 24px 22px;
  background: var(--bg-card);
  border: 1px solid var(--border);
  border-radius: var(--radius);
  transition: border-color 0.2s ease, box-shadow 0.2s ease,
    transform 0.2s ease;
}
a.pcard:hover {
  border-color: var(--ink-faint);
  box-shadow: 0 6px 20px rgba(20, 20, 19, 0.06);
  transform: translateY(-2px);
}
.pcard-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 18px;
}
.pcard-type {
  display: inline-flex;
  align-items: center;
  font-size: 13px;
  color: var(--ink-soft);
}
.pcard-dot {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  margin-right: 8px;
}
.pcard-status {
  font-size: 12px;
  color: var(--accent);
  background: var(--accent-wash);
  padding: 3px 9px;
  border-radius: 20px;
}
.pcard-name {
  font-size: 20px;
  font-weight: 600;
  color: var(--ink);
  margin: 0 0 10px;
  letter-spacing: -0.2px;
}
.pcard-desc {
  flex: 1;
  font-size: 14.5px;
  line-height: 1.85;
  color: var(--ink-soft);
  margin: 0 0 18px;
}
.pcard-tags {
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 16px;
}
.pcard-tag {
  font-size: 12px;
  padding: 3px 9px;
  margin: 0 6px 6px 0;
  border-radius: 4px;
  background: var(--bg-alt);
  color: var(--ink-soft);
}
.pcard-foot {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-top: 14px;
  border-top: 1px solid var(--border-soft);
  min-height: 46px;
}
.pcard-cta {
  font-size: 14px;
  color: var(--accent);
  font-weight: 500;
}
.pcard-hint {
  font-size: 13px;
  color: var(--ink-faint);
}
.pcard-qr {
  cursor: zoom-in;
  width: 72px;
  height: 72px;
  border-radius: 6px;
  border: 1px solid var(--border);
}
</style>
